<!-- TODO Fix hardcoded style -->
<div class="d-flex">
  <app-stop-icon
    [stopType]="stopType"
    [stopNumber]="stopNumber"
    [routeColor]="routeColor"
    style="display: inline-block"
  ></app-stop-icon>
  <span class="text-wrap ml-2">
    {{ stopText | address : "full" }}
  </span>
</div>
